module.exports = __webpack_public_path__ + "img/index-home.e82bb2dd.svg";